/**
 * ScheduleWarning — the inline notice shown when a workshop's schedule cannot be rendered.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
/** Visible note when the schedule can't be shown. Deliberately does NOT block
 *  Confirm — whether missing data should stop a publish is a product decision;
 *  making the gap legible is not. */
export function ScheduleWarning({ message }: { message: string }) {
  return (
    <p
      role="status"
      style={{
        margin: 0,
        padding: '8px 10px',
        borderRadius: 8,
        fontSize: 12.5,
        background: 'var(--nb-warn-soft)',
        color: 'var(--nb-warn)',
        border: '1px solid var(--nb-warn)',
      }}
    >
      {message}
    </p>
  );
}

/** Date + duration, capacity, and price — the at-a-glance facts. */
